export enum AiCallBannerMode {
	Invitation = 'invitation',
	AutoSwitched = 'auto_switched',
}
